import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useLocation, Link } from "react-router-dom";
import { TooltipContainer } from "@outplayed/tooltips";
import { TIER_LIST_ROLE_OPTIONS } from "@ugg/shared/query-params/filter-options/tier-lists/tier-list";
import { FilterSelect } from "@ugg/shared/interfaces/filter-manager.interface";

interface TierListRoleSplitProps extends FilterSelect {
  className?: string;
  defaultOption: (typeof TIER_LIST_ROLE_OPTIONS)[number];
  disableByQueueType?: boolean;
  disableTooltip?: boolean;
  isMobile?: boolean;
}

export default function TierListRoleSplit(props: TierListRoleSplitProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const { className, disableTooltip } = props;

  const displayRoleFilters = () => {
    return TIER_LIST_ROLE_OPTIONS.map((role) => {
      const isSelectedRole = role.path === location.pathname;
      const selectorClassNames = classnames("filter-tooltip-wrapper role-filter", {
        active: isSelectedRole,
      });

      return (
        <TooltipContainer key={role.value} tooltipInfo={t(role.label)} disableTooltip={disableTooltip}>
          <Link className={selectorClassNames} to={{ pathname: role.path, search: location.search }}>
            {isSelectedRole && role.imgActive ? role.imgActive : role.img}
          </Link>
        </TooltipContainer>
      );
    });
  };

  return <div className={classnames("role-filter-container", className)}>{displayRoleFilters()}</div>;
}
